/**
 * Conflict Banner (Epic C-4 — Bezetting & conflicten, Story C-4.3, UX-C5)
 *
 * Rode `role="alert"`-banner bovenin het planbord bij ≥1 conflict in de
 * zichtbare week. Rood is hier gerechtvaardigd (NFR-1): een conflict is een
 * echte foutsituatie — de kern-toepassing van de "rood alleen voor echte
 * fouten"-regel, niet een uitzondering erop.
 */

interface ConflictBannerProps {
  count: number;
  onOpenPanel: () => void;
}

export function ConflictBanner({ count, onOpenPanel }: ConflictBannerProps) {
  if (count === 0) return null;

  const label = count === 1 ? '1 indeling is niet meer werkbaar' : `${count} indelingen zijn niet meer werkbaar`;

  return (
    <div
      role="alert"
      data-testid="conflict-banner"
      className="flex items-center justify-between gap-3 px-4 py-3 border-b"
      style={{ backgroundColor: '#D6454514', borderColor: '#D6454540' }}
    >
      <span className="flex items-center gap-2 text-sm font-medium" style={{ color: '#D64545' }}>
        <span aria-hidden="true">&#9888;</span>
        {label}
      </span>
      <button
        type="button"
        data-testid="conflict-banner-open"
        onClick={onOpenPanel}
        className="text-sm font-semibold underline"
        style={{ color: '#D64545' }}
      >
        Bekijk conflicten
      </button>
    </div>
  );
}
